// extracted by mini-css-extract-plugin
module.exports = {"container":"_3vxdKUpStSHqoRjO8ttbBb","avatar":"_1kPPIo_6EFrfhp5N5_2jcX","content":"_2oSOXx8FNE2T9sotTVIygU","item":"_3_pZqT69F-ieuhTlQUloTf","name":"_2pYqsqBI7sYyPVpvgNlXSB"};